import { ACTION_LOGIN, ACTION_LOGOUT, CLEAR_REFRESH_PATH } from "../Action/AuthAction";

const init = {
    isLoggedIn: true,
    userInfo: {},
    refreshPath: window.location.pathname
}

const AuthReducer = (state = init, action) => {
    switch (action.type) {
        case ACTION_LOGIN:
            const { userInfo } = action;
            return { ...state, isLoggedIn: true, userInfo }
        case ACTION_LOGOUT:
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            return { ...state, isLoggedIn: false, userInfo: {} }
        case CLEAR_REFRESH_PATH:
            return { ...state, refreshPath: '' };
        default:
            return state;
    }
}

export default AuthReducer;